import moment from "moment";

export const renderSidebar = (sideBarLinks, user) => {
  let tempSidebar = sideBarLinks.filter(
    ({ key }) =>
      user?.privileges.includes(key) || key === "" || key === user.type
  );
  return tempSidebar;
};
export const getTimeLeft = (expirationTime) => {
  const futureDate = moment(expirationTime);
  const currentTime = moment();
  const duration = moment.duration(futureDate.diff(currentTime));

  const daysLeft = Math.floor(duration.asDays());
  const hoursLeft = Math.floor(duration.asHours());
  const minutesLeft = Math.floor(duration.asMinutes());
  const secondsLeft = Math.floor(duration.asSeconds());

  if (secondsLeft <= 0) {
    return "Expired";
  } else if (daysLeft > 0) {
    return `${daysLeft} days left`;
  } else if (hoursLeft > 0) {
    return `${hoursLeft} hours left`;
  } else if (minutesLeft > 0) {
    return `${minutesLeft} minutes left`;
  } else {
    return `${secondsLeft} seconds left`;
  }
};

export const numberWithCommas = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace(/\.00$/, "");
};

export const getQueryString = (params) => {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== "" && value !== undefined && value !== null
      )
    )
  ).toString();
};
export const calculateTotalAmount = (amount, data) => {
  const applicableFeeData = data?.find(
    (item) =>
      parseFloat(amount) >= parseFloat(item.from) &&
      parseFloat(amount) <= parseFloat(item.to)
  );

  if (!applicableFeeData) {
    return { totalAmount: null, error: "No applicable range found" };
  }

  const { fees, taxOnFees } = applicableFeeData;
  const fee = parseFloat(fees);
  const tax = (fee * parseFloat(taxOnFees)) / 100;
  const totalAmount = parseFloat(amount) + fee + tax;

  return { totalAmount };
};
